import { render, staticRenderFns } from "./UiBlockDocView.vue?vue&type=template&id=4583bfa5&scoped=true"
import script from "./UiBlockDocView.vue?vue&type=script&lang=js"
export * from "./UiBlockDocView.vue?vue&type=script&lang=js"
import style0 from "./UiBlockDocView.vue?vue&type=style&index=0&id=4583bfa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4583bfa5",
  null
  
)

export default component.exports